import { intelligentPhotoCaptureConstants } from '../constants';
export const INTELLIGENT_PHOTO_CAPTURE_ON_VIEW_CHANGE = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_ON_VIEW_CHANGE`;
export const INTELLIGENT_PHOTO_CAPTURE_SAVE_CAPTURED_PHOTO = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_SAVE_CAPTURED_PHOTO`;
export const INTELLIGENT_PHOTO_CAPTURE_CLICK_NEXT_QUESTION = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_ON_CLICK_NEXT_QUESTION`;
export const INTELLIGENT_PHOTO_CAPTURE_CAMERA_MODEL_SUCCESS = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_CAMERA_MODEL_SUCCESS`;
export const INTELLIGENT_PHOTO_CAPTURE_RESET_CAPTURED_PHOTO = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_RESET_SAVE_CAPTURED_PHOTO`;
export const INTELLIGENT_PHOTO_CAPTURE_RESET_IMAGE_ANALYZER_DETAILS = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_RESET_IMAGE_ANALYZER_DETAILS`;
export const INTELLIGENT_PHOTO_CAPTURE_IMAGE_DETAILS_REQUEST = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_IMAGE_DETAILS_REQUEST`;
export const INTELLIGENT_PHOTO_CAPTURE_PROGRESSIVE_IMAGE_MISC_ACTION = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_PROGRESSIVE_IMAGE_MISC_ACTION`;
export const photoCaptureIntelligentViewChangeAction = (view, sequenceScreenName, selectedTileId, contentType) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_ON_VIEW_CHANGE,
    payload: { view, sequenceScreenName, selectedTileId, contentType }
});
export const photoCaptureIntelligentSaveCapturedPhotoAction = (file) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_SAVE_CAPTURED_PHOTO,
    payload: { file }
});
export const photoCaptureIntelligentClickNextQuestionAction = (shouldMoveToNextQuestion) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_CLICK_NEXT_QUESTION,
    payload: { shouldMoveToNextQuestion }
});
export const photoCaptureIntelligentCameraModelSuccessAction = (cameraModel) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_CAMERA_MODEL_SUCCESS,
    payload: { cameraModel }
});
export const photoCaptureIntelligentResetSaveCapturedPhotoAction = () => ({
    type: INTELLIGENT_PHOTO_CAPTURE_RESET_CAPTURED_PHOTO,
    payload: null
});
export const photoCaptureIntelligentProgressiveImageMiscAction = (payload) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_PROGRESSIVE_IMAGE_MISC_ACTION,
    payload: payload
});
//# sourceMappingURL=photoCaptureIntelligentViewChangeActions.js.map